export interface ComboType {
  id: string;
  name: string;
}

export const COMBO_TYPES: ComboType[] = [
  { id: 'Combo Meal', name: 'Combo Meal' },
  { id: 'Breakfast Combo', name: 'Breakfast Combo' },
  { id: 'Kids Meal KM', name: 'Kids Meal KM' },
  { id: 'Kids Meal Breakfast', name: 'Kids Meal Breakfast' },
];

